export default __webpack_public_path__ + "static/media/Apache_PoweredBy.3b99da58.svg";